import { all, call, put, select, takeLatest } from "redux-saga/effects";
import * as customDataActions from "./actions";
import {
  FetchCustomDataList,
  FetchACustomData,
  FetchACustomDataAlias,
  DeleteACustomDataAlias,
  RemoveMappedKey,
  MapToAlias,
  CreateAlias,
  FetchAliasLogs,
  UpdateAlias,
  FetchCustomDataListV2,
} from "./services";
import {
  DELETE_ALIAS,
  DUPLICATE_MAP_KEY_NAME_MSG,
} from "../../app/Constants/Constants";
import { customCheckCountData } from "./helper";

export function* fetchCustomDataListSaga(action) {
  try {
    const response = yield call(FetchCustomDataList, action.payload);
    const customData =
      response && response.data && response.data.data
        ? response.data.data
        : null;
    yield put(customDataActions.FetchCustomDataSuccess(customData));
  } catch (error) {
    yield put(customDataActions.FetchCustomDataFailed(error));
  }
}

export function* fetchCustomEventListDataListSaga(action) {
  try {
    const response = yield call(FetchCustomDataList, action.payload);
    const customData =
      response && response.data && response.data.data ? response.data.data : [];
    yield put(customDataActions.FetchCustomEventListDataSuccess(customData));
  } catch (error) {
    yield put(customDataActions.FetchCustomEventListDataFailed(error));
  }
}

export function* fetchCustomDataAliasUnmapListSaga(action) {
  try {
    const response = yield call(FetchCustomDataList, action.payload);
    const customData =
      response && response.data && response.data.data ? response.data.data : [];
    yield put(customDataActions.FetchCustomDataAliasUnmapSuccess(customData));
  } catch (error) {
    yield put(customDataActions.FetchCustomDataAliasUnmapFailed(error));
  }
}
export function* fetchACustomDataSaga(action) {
  try {
    const response = yield call(FetchACustomData, action.payload);
    const customData =
      response && response.data && response.data.data
        ? response.data.data
        : null;
    if (response.data.success) {
      yield put(customDataActions.FetchACustomDataSuccess(customData));
    } else {
      yield put(
        customDataActions.FetchACustomDataFailed({
          error: response.data.message,
          name: "fetch",
        }),
      );
    }
  } catch (error) {
    yield put(
      customDataActions.FetchACustomDataFailed({
        error,
        name: "fetch",
      }),
    );
  }
}
export function* fetchACustomDataListSaga(action) {
  try {
    const response = yield call(FetchACustomData, action.payload);
    const customData =
      response && response.data && response.data.data
        ? response.data.data
        : null;
    if (response.data.success) {
      yield put(customDataActions.FetchACustomDataListSuccess(customData));
    } else {
      yield put(
        customDataActions.FetchACustomDataListFailed({
          error: response.data.message,
          name: "fetch",
        }),
      );
    }
  } catch (error) {
    yield put(
      customDataActions.FetchACustomDataListFailed({
        error,
        name: "fetch",
      }),
    );
  }
}
export function* fetchACustomDataAliasSaga(action) {
  try {
    const response = yield call(FetchACustomDataAlias, action.payload);
    const customDataAlias =
      response && response.data && response.data.data
        ? response.data.data
        : null;
    if (response.data.success) {
      yield put(
        customDataActions.FetchACustomDataAliasSuccess(customDataAlias),
      );
    } else {
      yield put(
        customDataActions.FetchACustomDataAliasFailed({
          error: response.data.message,
          name: "fetch",
        }),
      );
    }
  } catch (error) {
    yield put(
      customDataActions.FetchACustomDataAliasFailed({
        error,
        name: "fetch",
      }),
    );
  }
}
export function* deleteACustomDataAliasSaga(action) {
  try {
    const response = yield call(DeleteACustomDataAlias, action.payload);
    if (response.data.success) {
      yield put(
        customDataActions.DeleteAliasSuccess({
          ...response.data,
          type: DELETE_ALIAS,
        }),
      );
    } else {
      yield put(customDataActions.DeleteAliasFailed(response.data));
    }
  } catch (error) {
    yield put(customDataActions.DeleteAliasFailed(error));
  }
}
export function* removeMappedKeySaga(action) {
  try {
    const response = yield call(RemoveMappedKey, action.payload);
    if (response.data.success) {
      yield put(customDataActions.RemoveMappedKeySuccess(response.data));
    } else {
      yield put(customDataActions.RemoveMappedKeyFailed(response.data));
    }
  } catch (error) {
    yield put(customDataActions.RemoveMappedKeyFailed(error));
  }
}
export function* mapToAliasSaga(action) {
  try {
    const response = yield call(MapToAlias, action.payload);
    if (response.data.success) {
      yield put(customDataActions.MapToAliasSuccess(response.data));
    } else {
      const updatedErrorResponse =
        response.data.message === DUPLICATE_MAP_KEY_NAME_MSG
          ? {
              ...response.data,
              isDuplicate: true,
            }
          : response.data;
      yield put(customDataActions.MapToAliasFailed(updatedErrorResponse));
    }
  } catch (error) {
    yield put(customDataActions.MapToAliasFailed(error));
  }
}
export function* createAliasSaga(action) {
  try {
    const response = yield call(CreateAlias, action.payload);
    if (response.data.success) {
      yield put(customDataActions.CreateAliasSuccess(response.data));
    } else {
      yield put(customDataActions.CreateAliasFailed(response.data));
    }
  } catch (error) {
    yield put(customDataActions.MapToAliasFailed(error));
  }
}

export function* updateAliasSaga(action) {
  try {
    const response = yield call(UpdateAlias, action.payload);
    if (response.data.success) {
      yield put(customDataActions.UpdateAliasSuccess(response.data));
    } else {
      yield put(customDataActions.UpdateAliasFailed(response.data));
    }
  } catch (error) {
    yield put(customDataActions.MapToAliasFailed(error));
  }
}

export function* FetchAliasLogsSaga(action) {
  try {
    const response = yield call(FetchAliasLogs, action.payload);
    if (response && response.data && response.data.success) {
      yield put(customDataActions.FetchACollectorLogsSuccess(response?.data));
    } else {
      yield put(customDataActions.FetchACollectorLogsFailed(response.data));
    }
  } catch (error) {
    yield put(customDataActions.FetchACollectorLogsFailed(error));
  }
}

export function* fetchCustomDataListV2Saga(action) {
  const { payload } = action;
  try {
    const response = yield call(FetchCustomDataListV2, payload);
    const customData =
      response && response.data && response.data.data
        ? response.data.data
        : null;
    yield put(customDataActions.FetchCustomDataListSuccess(customData));
    // }));
  } catch (error) {
    yield put(customDataActions.FetchCustomDataListFailed(error));
  }
}

export function* loadMoreCustomDataListSaga(action) {
  const { payload } = action;
  try {
    const response = yield call(FetchCustomDataListV2, payload);
    const customData =
      response && response.data && response.data.data
        ? response.data.data
        : null;
    yield put(customDataActions.LoadMoreCustomDataListSuccess(customData));
  } catch (error) {
    yield put(customDataActions.LoadMoreCustomDataListFailed(error));
  }
}

export function* fetchACustomDataAliasCheckCountSaga(action) {
  try {
    const response = yield call(FetchACustomDataAlias, action.payload);
    const customDataAlias =
      response && response.data && response.data.data ? response.data : null;
    if (response.data.success) {
      yield put(
        customDataActions.FetchACustomDataAliasCheckCountSuccess(
          customCheckCountData(customDataAlias),
        ),
      );
    } else {
      yield put(
        customDataActions.FetchACustomDataAliasCheckCountFailed({
          error: response.data.message,
          name: "fetch",
        }),
      );
    }
  } catch (error) {
    yield put(
      customDataActions.FetchACustomDataAliasCheckCountFailed({
        error,
        name: "fetch",
      }),
    );
  }
}

export function* customDataWatcher() {
  yield all([
    takeLatest(
      customDataActions.types.FETCH_CUSTOM_DATA,
      fetchCustomDataListSaga,
    ),
    takeLatest(
      customDataActions.types.FETCH_CUSTOM_DATA_ALIAS_UNMAP,
      fetchCustomDataAliasUnmapListSaga,
    ),
    takeLatest(
      customDataActions.types.FETCH_A_CUSTOM_DATA,
      fetchACustomDataSaga,
    ),
    takeLatest(
      customDataActions.types.FETCH_A_CUSTOM_DATA_LIST,
      fetchACustomDataListSaga,
    ),
    takeLatest(
      customDataActions.types.FETCH_A_CUSTOM_DATA_ALIAS,
      fetchACustomDataAliasSaga,
    ),
    takeLatest(
      customDataActions.types.DELETE_ALIAS,
      deleteACustomDataAliasSaga,
    ),
    takeLatest(customDataActions.types.REMOVE_MAPPED_KEY, removeMappedKeySaga),
    takeLatest(customDataActions.types.MAP_TO_ALIAS, mapToAliasSaga),
    takeLatest(customDataActions.types.CREATE_ALIAS, createAliasSaga),
    takeLatest(customDataActions.types.UPDATE_ALIAS, updateAliasSaga),
    takeLatest(customDataActions.types.FETCH_A_ALIAS_LOGS, FetchAliasLogsSaga),
    takeLatest(
      customDataActions.types.FETCH_CUSTOM_DATA_EVENT_LIST,
      fetchCustomEventListDataListSaga,
    ),
    takeLatest(
      customDataActions.types.FETCH_CUSTOM_DATA_LIST,
      fetchCustomDataListV2Saga,
    ),
    takeLatest(
      customDataActions.types.LOAD_MORE_CUSTOM_DATA_LIST,
      loadMoreCustomDataListSaga,
    ),
    takeLatest(
      customDataActions.types.FETCH_A_CUSTOM_DATA_ALIAS_CHECK_COUNT,
      fetchACustomDataAliasCheckCountSaga,
    ),
  ]);
}
